import React, { useState, useEffect, useCallback } from 'react';

export default function BlogHeroSlider({ data, isPageHero = false }) {
  const { slides = [], autoplay: autoplayEnabled, autoplayDelay = 5000 } = data || {};
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(!autoplayEnabled);

  const next = useCallback(() => {
    setCurrent(c => (c + 1) % slides.length);
  }, [slides.length]);

  const prev = () => setCurrent(c => (c - 1 + slides.length) % slides.length);

  useEffect(() => {
    if (paused || slides.length <= 1) return;
    const t = setInterval(next, autoplayDelay);
    return () => clearInterval(t);
  }, [paused, next, slides.length, autoplayDelay]);

  if (!slides.length) return null;
  const slide = slides[current];

  return (
    <div className={`blog-hero-slider ${isPageHero ? 'blog-hero-slider--page' : ''}`}>
      <div className="blog-hero-slider__viewport">
        {slide.image ? (
          <img
            key={current}
            src={slide.image}
            alt={slide.alt || slide.title || ''}
            className="blog-hero-slider__image"
          />
        ) : (
          <div className="blog-hero-slider__placeholder" />
        )}

        <div className="blog-hero-slider__gradient" />

        <div className="blog-hero-slider__content">
          {slide.tag && (
            <p className="blog-hero-slider__tag">{slide.tag}</p>
          )}

          <h2 className="blog-hero-slider__title">{slide.title}</h2>

          {slide.description && (
            <p className="blog-hero-slider__description">{slide.description}</p>
          )}

          {slide.cta && (
            <a
              href={slide.ctaLink || '#'}
              className="blog-hero-slider__cta"
            >
              {slide.cta}
              <span className="blog-hero-slider__cta-arrow">→</span>
            </a>
          )}
        </div>
      </div>

      {slides.length > 1 && (
        <div className="blog-hero-slider__controls">
          <button onClick={prev} className="blog-hero-slider__nav-btn" aria-label="Previous slide">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--phys-ink)" strokeWidth="1.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <span className="blog-hero-slider__counter">{current + 1} / {slides.length}</span>
          <button onClick={next} className="blog-hero-slider__nav-btn" aria-label="Next slide">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--phys-ink)" strokeWidth="1.5">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
          <button
            onClick={() => setPaused(p => !p)}
            className="blog-hero-slider__pause-btn"
            aria-label={paused ? 'Play' : 'Pause'}
          >
            {paused ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--phys-ink)" stroke="none">
                <polygon points="6 4 20 12 6 20" />
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--phys-ink)" stroke="none">
                <rect x="6" y="4" width="2" height="16" />
                <rect x="14" y="4" width="2" height="16" />
              </svg>
            )}
          </button>
        </div>
      )}
    </div>
  );
}
